import React,{useState,useEffect} from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './whatsapp';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import { useNavigate,Link } from 'react-router-dom';
import Chat from './chat';
import {Helmet} from 'react-helmet';
import Call from './call';
import Marquee from './marquee';


const VideoGallery=()=>{

     const navigate=useNavigate();
   
   const [city,setcity]=useState([]);
   
   const [lowbudget,setlowbudget]=useState([]);
   const [affordable,setaffordable]=useState([]);
  
    const [pagination,setPagination]=useState({
        total:0,totalPages:1,page:1

    })
   const [page,setpage]=useState(1);

   const [cat,setcatsubcat]=useState([]);
    const [cats,setcatsubcats]=useState([]);

    const [showmodal,setshowmodal]=useState(false);

    const [selected,setselected]=useState('');

   

   useEffect(()=>{
    const fetchafford=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/designideas?page=${page}&limit=6`);
     
     setaffordable(res.data.data);
     setPagination({
        total:res.data.total,
        page:res.data.page,
        totalPages:res.data.totalPages
     })
      }catch(error){
      console.error(error);
      }
    }
    fetchafford();
   },[page]);

  useEffect(()=>{
   
     const fetchCty=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/pj`);
     setcity(res.data);
      }catch(error){
      console.error(error);
      }
    }
    
    
    const fetlowbudget=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/lowbudgetinetrior`);
     
     setlowbudget(res.data);
      }catch(error){
      console.error(error);
      }
    }
    
    const fetcatsubcat=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/designideasall`);
    
     setcatsubcat(res.data.category);
    setcatsubcats(res.data.subcategory);
      }catch(error){
      console.error(error);
      }
    }
    
   fetcatsubcat();
    fetchCty();
   fetlowbudget();
  },[]);
    
  const handleCloseModal=()=>{
    setshowmodal(false);
  }

  const handleclick=(item)=>{
    setshowmodal(true);
    setselected(item);

  }

    return (

    <>
    <div className='app'>

    
    <Header />
    <Marquee/>
     <Helmet>
            <title>Pranati Interior - Kolkata best Interior</title>
            <meta name="description" content="Welcome to Kolkata best interior" />
    
            <link rel="canonical" href="https://squareandangle.pranatigroup.in/video_gallery" />
    
            <meta property="og:title" content="Pranati interior" />
            <meta property="og:description" content="Kolkata best Interior" />
            <meta property="og:image" content="/images/preview.png" />
            <meta property="og:url" content="https://squareandangle.pranatigroup.in/video_gallery" />
    
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Pranati interior" />
            <meta name="twitter:description" content="Kolkata best Interior" />
            <meta name="twitter:image" content="/images/preview.png" />
    
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Pranati Interior",
                "url": "https://squareandangle.pranatigroup.in/video_gallery",
                "description": "Kolkata best Interior",
                "image": "https://squareandangle.pranatigroup.in/images/preview.png",
                "areaServed": "Kolkata",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Kolkata",
                  "addressRegion": "West Bengal",
                  "addressCountry": "IN"
                }
              })}
            </script>
          </Helmet>
        
   
    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>Interior Design Video Kolkata</h2>
                        <ul>
                            <li>Find affordable, best interior designers designing, decorating, and renovating videos according to your preferences and budget.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    <div className="project-area">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="project-menu text-center mb-40">
                        <button className="active" data-filter="*">View All</button>
                        <button data-filter=".cat1">Commercial</button>
                        <button data-filter=".cat2">Residential</button>
                        <button data-filter=".cat3">False Ceiling</button>
                        <button data-filter=".cat4">Furniture</button>
                    </div>
                </div>
            </div>
           <div className="row grid">

  {city.map((item, index) => (
    <div
      className="col-lg-4 col-md-6 col-sm-6 col-12 project cat2 mb-4"
      key={item._id || index}
    >

      <div
        style={{
          background: "#fff",
          borderRadius: "14px",
          overflow: "hidden",
          border: "1px solid #eee",
          boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
          transition: "all 0.3s ease",
          height: "100%",
        }}
      >

        {/* Image */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "280px",
            overflow: "hidden",
           
          }}
         
        >
          <img
            src={uploadUrl(item.image)}
            alt={item.description || "Interior Design Kolkata"}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              transition: "transform 0.5s ease",
            }}
          />
        </div>

        {/* Content */}
        <div
          style={{
            padding: "18px",
          }}
        >

          

         
         
          <button
            type="button"
            onClick={() => handleclick(item)}
            style={{
              width: "100%",
              height: "48px",
              border: "none",
              borderRadius: "7px",
              background: "#e63946",
              color: "#fff",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              boxShadow: "0 4px 12px rgba(230,57,70,0.25)",
            }}
          >
            <span>View Design</span>

            <i
              className="fa fa-arrow-right"
              style={{
                fontSize: "14px",
              }}
            ></i>
          </button>

        </div>

      </div>

    </div>
  ))}

</div>

        </div>
    </div>
    
     </div>
   
   {showmodal && (
     <div
          className="custom-modal-overlay"
          onClick={handleCloseModal}
        >

          <div
            className="custom-modal"
            onClick={(e) => e.stopPropagation()}
          >

            
            <button
              className="modal-close"
              onClick={handleCloseModal}
              aria-label="Close"
            >
              &times;
            </button>

            
            <div className="modal-main-content">

             
              <div className="modal-image">

                <img
                  src={uploadUrl(selected.image)}
                  alt={
                    selected.description ||
                    "Interior Design"
                  }
                />

              </div>

              
              <div className="modal-details">

                <span className="modal-label">
                  INTERIOR DESIGN
                </span>

                <h2>
                  {selected.description ||
                    "Interior Design"}
                </h2>

                {selected.category && (
                  <p>
                    <strong>Category:</strong>{" "}
                    {selected.category}
                  </p>
                )}

                {selected.subcategory && (
                  <p>
                    <strong>Subcategory:</strong>{" "}
                    {selected.subcategory}
                  </p>
                )}

                <p>
                  Get professional interior design
                  advice according to your requirements
                  and budget.
                </p>

                
                <a
                  href={`https://api.whatsapp.com/send?phone=6289001010&text=${encodeURIComponent(
                    `Hi Pranati Interior! I am interested in ${
                      selected.description ||
                      "this interior design"
                    }. I need more information.`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-btn"
                >
                  <i className="fa fa-whatsapp"></i>

                  Enquire on WhatsApp
                </a>

              </div>
            </div>

            
            

          </div>
        </div>
   )}
    
   
   
  
    <Footer />
   
       <WhatsAppButton />
      <Chat/>
      <Call/>

       <style>{`

       

        .custom-modal-overlay {
          position: fixed;
          inset: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.78);
          z-index: 999999;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          overflow-y: auto;
        }

       

        .custom-modal {
          width: 100%;
          max-width: 1100px;
          max-height: 92vh;
          overflow-y: auto;
          background: #ffffff;
          border-radius: 15px;
          position: relative;
          padding: 30px;
          animation: modalOpen 0.25s ease;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        }

        @keyframes modalOpen {

          from {
            opacity: 0;
            transform: scale(0.94);
          }

          to {
            opacity: 1;
            transform: scale(1);
          }

        }

       

        .modal-close {
          position: absolute;
          right: 15px;
          top: 15px;

          width: 42px;
          height: 42px;

          border: none;
          border-radius: 50%;

          background: #222;
          color: #fff;

          font-size: 28px;
          line-height: 35px;

          cursor: pointer;

          z-index: 10;

          transition: 0.3s;
        }

        .modal-close:hover {
          background: #e63946;
          transform: rotate(90deg);
        }

        

        .modal-main-content {
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: 35px;
          align-items: center;
        }

        

        .modal-image img {
          width: 100%;
          height: 450px;
          object-fit: cover;
          border-radius: 12px;
          display: block;
        }

       

        .modal-details {
          padding: 15px;
        }

        .modal-label {
          color: #e63946;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1px;
        }

        .modal-details h2 {
          font-size: 30px;
          margin: 12px 0 20px;
          color: #222;
        }

        .modal-details p {
          color: #666;
          line-height: 1.7;
          margin-bottom: 12px;
        }

       

        .whatsapp-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;

          background: #25d366;
          color: #fff;

          padding: 13px 22px;

          border-radius: 6px;

          text-decoration: none;

          margin-top: 12px;

          font-weight: 600;

          transition: 0.3s;
        }

        .whatsapp-btn:hover {
          background: #1da851;
          color: #fff;
          transform: translateY(-2px);
        }

        .whatsapp-btn i {
          font-size: 20px;
        }

       

        .related-products {
          margin-top: 40px;
          padding-top: 30px;
          border-top: 1px solid #eeeeee;
        }

        .related-products h3 {
          font-size: 25px;
          margin: 0;
          color: #222;
        }

        .related-line {
          width: 55px;
          height: 3px;
          background: #e63946;
          margin: 10px 0 25px;
        }

       

        .related-product-card {
          background: #fff;
          border: 1px solid #eeeeee;
          border-radius: 10px;
          overflow: hidden;
          height: 100%;
          transition: all 0.3s ease;
        }

        .related-product-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        }

        

        .product-image {
          width: 100%;
          height: 180px;
          overflow: hidden;
          background: #f5f5f5;
        }

        .product-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: 0.4s;
        }

        .related-product-card:hover
        .product-image img {
          transform: scale(1.05);
        }

        

        .product-info {
          padding: 15px;
        }

        .product-info h4 {
          font-size: 17px;
          color: #222;
          margin: 0 0 8px;
          font-weight: 600;
        }

        .product-description {
          font-size: 13px;
          color: #777 !important;
          line-height: 1.5 !important;
          margin-bottom: 8px !important;
        }

        .product-price {
          color: #e63946;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        

        .view-product-btn {
          width: 100%;
          border: none;
          background: #222;
          color: #fff;
          padding: 10px 15px;
          border-radius: 5px;
          cursor: pointer;
          transition: 0.3s;
        }

        .view-product-btn:hover {
          background: #e63946;
        }

        

        .products-loading {
          text-align: center;
          padding: 40px 10px;
          color: #777;
        }

        .spinner {
          width: 35px;
          height: 35px;
          border: 4px solid #eeeeee;
          border-top: 4px solid #e63946;
          border-radius: 50%;
          margin: 0 auto 15px;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {

          100% {
            transform: rotate(360deg);
          }

        }

       

        .no-products {
          text-align: center;
          padding: 35px;
          color: #777;
        }

        .no-products i {
          font-size: 35px;
          color: #ccc;
          margin-bottom: 10px;
        }

       

        .pagination-btn {
          border: none;
          padding: 10px 18px;
          border-radius: 5px;
          background: #222;
          color: #fff;
          cursor: pointer;
        }

        .pagination-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
        }

       

        @media (max-width: 768px) {

          .custom-modal {
            padding: 20px;
            max-height: 95vh;
            border-radius: 10px;
          }

          .modal-main-content {
            grid-template-columns: 1fr;
            gap: 15px;
          }

          .modal-image img {
            height: 300px;
          }

          .modal-details {
            padding: 5px;
          }

          .modal-details h2 {
            font-size: 23px;
          }

          .modal-close {
            width: 36px;
            height: 36px;
            font-size: 24px;
          }

          .product-image {
            height: 160px;
          }

        }

       

        @media (max-width: 480px) {

          .custom-modal-overlay {
            padding: 10px;
          }

          .custom-modal {
            padding: 15px;
          }

          .modal-image img {
            height: 240px;
          }

          .modal-details h2 {
            font-size: 20px;
          }

          .related-products h3 {
            font-size: 21px;
          }

          .product-image {
            height: 150px;
          }

        }

      `}</style>
    </>
    )
}

export default VideoGallery;